import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPortalRegisterView } from "../../lib/analytics";

export default function PortalRouteTracker() {
  const location = useLocation();
  const lastTrackedRegisterPath = useRef<string | null>(null);

  useEffect(() => {
    if (location.pathname !== "/register") {
      return;
    }

    const pagePath = `${location.pathname}${location.search}`;
    if (lastTrackedRegisterPath.current === pagePath) {
      return;
    }

    lastTrackedRegisterPath.current = pagePath;
    trackPortalRegisterView(pagePath);
  }, [location.pathname, location.search]);

  return null;
}
